export default __webpack_public_path__ + "static/media/SubVideo1.56f0f277.png";